import moment from 'moment';
const now = moment();
export default function getCopyrightYear() {
  return now.year();
}
//# sourceMappingURL=copyright-year.js.map